import { POST, GET } from "./_config";

//user
export const addNewsLetterData = async (body) =>
  await POST("/news-letter", body);

//admin
export const getNewsLetterList = async (query) =>
  await GET(`/news-letter/list?${query || ""}`, true);

export const getNewsLetterData = async () =>
  await GET("/news-letter/get-list", true);

export const sendEmail = async (body) =>
  await POST("/news-letter/send-mail", body, true);
